// Remove these unused imports/variables:
// const { user, refreshUser } = useAuth();  // Remove if not used
// const [loading, setLoading] = useState(false);  // Remove if not used
// const [plans, setPlans] = useState([]);  // Remove if not used
// const [currentSubscription, setCurrentSubscription] = useState(null);  // Remove if not used

// Simplified version:
import React from 'react';
import ErrorBoundary from '../components/ErrorBoundary';

const BillingPage = ({ upgradeMode = false }) => {
  return (
    <ErrorBoundary title="Billing Error" message="Unable to load billing page">
      <div className="billing-page">
        <div className="billing-header">
          <h1>{upgradeMode ? 'Upgrade Your Plan' : 'Billing & Subscription'}</h1>
          <p>Billing features coming soon...</p>
        </div>
      </div>
    </ErrorBoundary>
  );
};

export default BillingPage;